import React, { useEffect, useMemo, useState } from 'react';
import { useIsDarkTheme } from '../../hooks/useDataTheme';

function darkVariantUrl(src) {
  if (!src) return '';
  return String(src).replace(/(\.[a-z0-9]+)(\?.*)?$/i, '_dark$1$2');
}

/**
 * Иллюстрация лендинга: JPG из volume при деплое; при 404 — скрывается, остаётся CSS-оформление секции.
 * Тёмная тема: `{name}_dark.jpg` рядом с `{name}.jpg`; если тёмного файла нет — светлый кадр.
 * `fallbackSrc` — второй файл, если основной отсутствует. `preferLight` — не подменять на `_dark`.
 */
export default function LandingOptionalImage({
  src,
  fallbackSrc,
  alt,
  className,
  loading = 'lazy',
  preferLight = false,
}) {
  const isDark = useIsDarkTheme();
  const candidates = useMemo(
    () => [src, fallbackSrc].filter(Boolean),
    [src, fallbackSrc],
  );
  const [srcIndex, setSrcIndex] = useState(0);
  const [failedDark, setFailedDark] = useState(false);

  useEffect(() => {
    setSrcIndex(0);
    setFailedDark(false);
  }, [src, fallbackSrc]);

  const currentSrc = candidates[srcIndex] || '';
  const darkSrc = useMemo(() => darkVariantUrl(currentSrc), [currentSrc]);
  const actual =
    !preferLight && isDark && darkSrc && darkSrc !== currentSrc && !failedDark
      ? darkSrc
      : currentSrc;

  if (!currentSrc) return null;

  return (
    <img
      key={actual}
      src={actual}
      alt={alt || ''}
      className={className}
      decoding="async"
      loading={loading}
      onError={() => {
        if (actual !== currentSrc) {
          setFailedDark(true);
          return;
        }
        setSrcIndex((index) => index + 1);
      }}
    />
  );
}
